export class DataError{
    HttpStatusCode: number;
    Message: string;
    ServiceCall: string;
    constructor(status: number, message: string, service: string){
        this.HttpStatusCode = status;
        this.Message = message;
        this.ServiceCall = service;
    }
}